import {
  animateSavedNavItemButton,
  toggleSavedNavItemPopover,
} from '@modules/leftNavSidebar/components/SavedNavItem/utils';
import {
  useAddFeatureUserTag,
  useHasFeatureUserTag,
} from '@modules/userTags/features/hooks';
import { FeatureUserTag } from '@modules/userTags/features/types';
import { Dialog, DialogProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SaveArtefactTransitionComponent } from './SaveArtefactTransitionComponent';

export interface SaveArtefactConfirmDialogProps
  extends Omit<DialogProps, 'TransitionComponent' | 'TransitionProps'> {
  artefactRoute: string | null;
  shouldSkipRedirect?: boolean;
}

export const SaveArtefactConfirmDialog = ({
  artefactRoute,
  shouldSkipRedirect = false,
  ...props
}: SaveArtefactConfirmDialogProps) => {
  const navigate = useNavigate();
  const { hasTag, isLoading } = useHasFeatureUserTag();
  const { addFeatureUserTag } = useAddFeatureUserTag();
  const isSavedNavbarItemPopoverIntroduced = hasTag(
    FeatureUserTag.SavedNavbarItemPopoverIntroduced,
  );

  return (
    <Dialog
      {...props}
      TransitionComponent={SaveArtefactTransitionComponent}
      TransitionProps={{
        exit: Boolean(artefactRoute),
        onExited: () => {
          if (artefactRoute) {
            animateSavedNavItemButton();
            if (!isSavedNavbarItemPopoverIntroduced && !isLoading) {
              toggleSavedNavItemPopover();
              addFeatureUserTag({
                tag: FeatureUserTag.SavedNavbarItemPopoverIntroduced,
                shouldRefetchQueries: true,
              });
            }

            if (!shouldSkipRedirect) {
              navigate(artefactRoute);
            }
          }
        },
      }}
    >
      {props.children}
    </Dialog>
  );
};
